import React, { useEffect, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import { Button, LoadingContent, Modal, Select } from '../../../components'
import PdcaLayout from '../base/pdcaLayout'
import PdcaPageHeader from '../components/pdcapageheader/pdcapageheader'
import PdcaEmptyState from '../components/pdcaemptystate/pdcaemptystate'
import PdcaPlanoCard from '../components/pdcaplanocard/pdcaplanocard'
import Detalheplano from '../detalheplano/detalheplano'
import {
  fetchHistory,
  HISTORY_PAGE_SIZE,
  setHistoryMotivoFilter
} from './redux/historyActions'
import './history.scss'

const obterTipoPlano = (tipoPlano, nls) => {
  const mapa = {
    diario: nls.planTypeDaily,
    semanal: nls.planTypeWeekly,
    mensal: nls.planTypeMonthly
  }

  return mapa[tipoPlano] || tipoPlano
}

const obterEscopo = (item, nls) => {
  if (item.lojaNome) return item.lojaNome
  if (item.produtoNome) return item.produtoNome
  return nls.scopeCompany
}

const obterMotivoConcluido = (motivoconcluido, nls) => {
  const mapa = {
    rejeitado_plan: nls.rejeitado_plan,
    rejeitado_do: nls.rejeitado_do,
    rejeitado_check: nls.rejeitado_check,
    padronizado: nls.padronizado,
    pivotado: nls.pivotado,
    escalonado: nls.escalonado,
    encerrado: nls.encerrado
  }

  return mapa[motivoconcluido] || motivoconcluido || nls.naodisponivel
}

const formatarDataInput = data => {
  const ano = data.getFullYear()
  const mes = String(data.getMonth() + 1).padStart(2, '0')
  const dia = String(data.getDate()).padStart(2, '0')
  return `${ano}-${mes}-${dia}`
}

const obterHojeInput = () => formatarDataInput(new Date())

const formatarPercentual = (valor, nls) => {
  if (valor === null || valor === undefined || String(valor).trim() === '') {
    return nls.naodisponivel
  }

  const texto = String(valor).trim()
  return texto.endsWith('%') ? texto : `${texto}%`
}

const formatarValorTexto = (valor, nls) => {
  if (valor === null || valor === undefined || String(valor).trim() === '') {
    return nls.naodisponivel
  }

  return String(valor).trim()
}

export default () => {
  const dispatch = useDispatch()
  const { idProjetos } = useParams()

  const { sistema } = useSelector(state => state.layoutState)
  const nls = require(`./nls/${sistema.idioma}.json`)

  const {
    projetoId,
    empresaPdcaExiste,
    contextoCarregado
  } = useSelector(state => state.pdcaState.pdcaBaseState)

  const {
    itens = [],
    totalItens = 0,
    totalPaginas = 0,
    pageId = 1,
    pageSize = HISTORY_PAGE_SIZE,
    resumo = null,
    filtros = {},
    loading = false,
    loaded = false,
    error = null
  } = useSelector(state => state.pdcaState.pdcaHistoryState || {})

  const statusOptions = useMemo(() => ([
    { label: nls.todos, value: 'todos' },
    { label: nls.rejeitado_plan, value: 'rejeitado_plan' },
    { label: nls.rejeitado_do, value: 'rejeitado_do' },
    { label: nls.rejeitado_check, value: 'rejeitado_check' },
    { label: nls.padronizado, value: 'padronizado' },
    { label: nls.pivotado, value: 'pivotado' },
    { label: nls.escalonado, value: 'escalonado' },
    { label: nls.encerrado, value: 'encerrado' }
  ]), [
    nls.todos,
    nls.rejeitado_plan,
    nls.rejeitado_do,
    nls.rejeitado_check,
    nls.padronizado,
    nls.pivotado,
    nls.escalonado,
    nls.encerrado
  ])

  const [dataInicial, setDataInicial] = useState(filtros?.dataInicial || '')
  const [dataFinal, setDataFinal] = useState(filtros?.dataFinal || '')
  const [erroFiltro, setErroFiltro] = useState(null)
  const [resumoModalAberto, setResumoModalAberto] = useState(false)
  const [detalheOpen, setDetalheOpen] = useState(false)
  const [planoIdSelecionado, setPlanoIdSelecionado] = useState(null)

  const contextoValido =
    contextoCarregado &&
    String(projetoId) === String(idProjetos)

  const contextoInconsistente = contextoCarregado && !empresaPdcaExiste
  const subtitle = `${totalItens} ${totalItens === 1 ? nls.summaryItemSingular : nls.summaryItemPlural}`
  const hojeInput = obterHojeInput()

  const statusSelecionado = statusOptions.find(
    option => option.value === (filtros?.motivoconcluido || 'todos')
  ) || statusOptions[0]

  useEffect(() => {
    setDataInicial(filtros?.dataInicial || '')
    setDataFinal(filtros?.dataFinal || '')
  }, [filtros?.dataInicial, filtros?.dataFinal])

  useEffect(() => {
    if (!idProjetos || !contextoValido || !empresaPdcaExiste) return
    if (!filtros?.dataInicial || !filtros?.dataFinal) return

    dispatch(fetchHistory({
      projetoId: idProjetos,
      dataInicial: filtros.dataInicial,
      dataFinal: filtros.dataFinal,
      pageId: pageId || 1,
      pageSize: pageSize || HISTORY_PAGE_SIZE,
      motivoconcluido: filtros?.motivoconcluido || 'todos'
    }))
  }, [
    dispatch,
    idProjetos,
    contextoValido,
    empresaPdcaExiste
  ])

  const handlePesquisar = () => {
    if (!dataInicial || !dataFinal) {
      setErroFiltro(nls.filterErrorRequiredDates)
      return
    }

    if (dataFinal < dataInicial) {
      setErroFiltro(nls.filterErrorEndBeforeStart)
      return
    }

    if (dataInicial > hojeInput || dataFinal > hojeInput) {
      setErroFiltro(nls.filterErrorFutureDate)
      return
    }

    setErroFiltro(null)

    dispatch(fetchHistory({
      projetoId: idProjetos,
      dataInicial,
      dataFinal,
      pageId: 1,
      pageSize: HISTORY_PAGE_SIZE,
      motivoconcluido: filtros?.motivoconcluido || 'todos'
    }))
  }

  const handleSelecionarStatus = e => {
    dispatch(setHistoryMotivoFilter(e?.value?.value || 'todos'))
  }

  const handlePaginaAnterior = () => {
    if (pageId <= 1) return

    dispatch(fetchHistory({
      projetoId: idProjetos,
      dataInicial: filtros?.dataInicial,
      dataFinal: filtros?.dataFinal,
      pageId: pageId - 1,
      pageSize: pageSize || HISTORY_PAGE_SIZE,
      motivoconcluido: filtros?.motivoconcluido || 'todos'
    }))
  }

  const handlePaginaProxima = () => {
    if (pageId >= totalPaginas) return

    dispatch(fetchHistory({
      projetoId: idProjetos,
      dataInicial: filtros?.dataInicial,
      dataFinal: filtros?.dataFinal,
      pageId: pageId + 1,
      pageSize: pageSize || HISTORY_PAGE_SIZE,
      motivoconcluido: filtros?.motivoconcluido || 'todos'
    }))
  }

  const handleDetalhes = planoId => {
    if (!planoId) {
      return
    }

    setPlanoIdSelecionado(planoId)
    setDetalheOpen(true)
  }

  const itensFiltrados = Array.isArray(itens)
    ? itens.filter(item => {
        if ((filtros?.motivoconcluido || 'todos') === 'todos') {
          return true
        }

        return item.motivoconcluido === filtros?.motivoconcluido
      })
    : []

  const actions = [
    { key: 'details', label: nls.actionDetails, primary: true }
  ]

  const podeAbrirResumo =
    !!filtros?.dataInicial &&
    !!filtros?.dataFinal &&
    !!resumo

  return (
    <PdcaLayout>
      <div className='box-pdca-history'>
        <PdcaPageHeader
          title={nls.pageTitle}
          subtitle={subtitle}
        />

        <div className='box-pdca-history-search-box'>
          <div className='box-pdca-history-filters'>
            <div className='box-pdca-history-filter-field box-pdca-history-filter-field-date'>
              <label>{nls.filterStartDate}</label>
              <input
                type='date'
                value={dataInicial}
                max={hojeInput}
                onChange={e => setDataInicial(e.target.value)}
              />
            </div>

            <div className='box-pdca-history-filter-field box-pdca-history-filter-field-date'>
              <label>{nls.filterEndDate}</label>
              <input
                type='date'
                value={dataFinal}
                max={hojeInput}
                onChange={e => setDataFinal(e.target.value)}
              />
            </div>

            <div className='box-pdca-history-filter-action'>
              <Button color='primary' onClick={handlePesquisar}>
                {nls.filterSearch}
              </Button>
            </div>

            <div className='box-pdca-history-status-filter'>
              <div className='box-pdca-history-status-select'>
                <Select
                  name='motivoconcluidoHistory'
                  label={nls.filterStatus}
                  options={statusOptions}
                  selected={statusSelecionado || {}}
                  action={handleSelecionarStatus}
                  selectedItem={false}
                  optionLabel='label'
                  optionValue='value'
                />
              </div>
            </div>

            <div className='box-pdca-history-summary-action'>
              <Button
                color='default'
                onClick={() => setResumoModalAberto(true)}
                disabled={!podeAbrirResumo}
              >
                {nls.filterSummary}
              </Button>
            </div>
          </div>
        </div>

        {erroFiltro && (
          <div className='box-pdca-history-inline-error'>
            {erroFiltro}
          </div>
        )}

        {contextoInconsistente && (
          <div className='box-pdca-history-inline-error'>
            {nls.contextError}
          </div>
        )}

        {!contextoInconsistente && (
          <LoadingContent loading={loading}>
            {error && (
              <div className='box-pdca-history-inline-error'>
                {nls.loadError}
              </div>
            )}

            {!error && filtros?.dataInicial && filtros?.dataFinal && (
              <>
                {itensFiltrados.length ? (
                  <div className='box-pdca-history-list'>
                    {itensFiltrados.map(item => (
                      <PdcaPlanoCard
                        key={`history-${item.id}`}
                        item={item}
                        nls={nls}
                        titlePrefix={nls.planNumber}
                        typeLabel={obterTipoPlano(item.tipoPlano, nls)}
                        scopeText={obterEscopo(item, nls)}
                        badges={[
                          {
                            key: `motivo-${item.id}`,
                            variant: 'neutral',
                            label: obterMotivoConcluido(item.motivoconcluido, nls)
                          },
                          {
                            key: `tipo-${item.id}`,
                            variant: 'neutral',
                            label: obterTipoPlano(item.tipoPlano, nls)
                          }
                        ]}
                        metaItems={[
                          { label: nls.metaEndDate, value: formatarValorTexto(item.dataFinal, nls) },
                          { label: nls.metaConclusionReason, value: obterMotivoConcluido(item.motivoconcluido, nls) },
                          { label: nls.metaNpsBefore, value: formatarValorTexto(item.npsAntes, nls) },
                          { label: nls.metaNpsAfter, value: formatarValorTexto(item.npsDepois, nls) },
                          { label: nls.metaDeltaNps, value: formatarValorTexto(item.deltaNps, nls) },
                          { label: nls.metaImprovementPercentage, value: formatarPercentual(item.melhoriaPercentualTotal, nls) }
                        ]}
                        actions={actions}
                        onDetalhes={handleDetalhes}
                      />
                    ))}
                  </div>
                ) : (
                  <PdcaEmptyState
                    title={
                      itens.length
                        ? nls.emptyStatusFilter
                        : nls.emptyState
                    }
                  />
                )}

                {loaded && totalPaginas > 1 && itens.length > 0 && (
                  <div className='box-pdca-history-pagination'>
                    <button
                      type='button'
                      className='box-pdca-history-pagination-button'
                      onClick={handlePaginaAnterior}
                      disabled={pageId <= 1}
                    >
                      {nls.paginationPrevious}
                    </button>

                    <div className='box-pdca-history-pagination-text'>
                      {pageId}/{totalPaginas}
                    </div>

                    <button
                      type='button'
                      className='box-pdca-history-pagination-button'
                      onClick={handlePaginaProxima}
                      disabled={pageId >= totalPaginas}
                    >
                      {nls.paginationNext}
                    </button>
                  </div>
                )}
              </>
            )}
          </LoadingContent>
        )}

        <Modal
          name='pdca-history-summary'
          title={nls.summaryTitle}
          open={resumoModalAberto}
          close={() => setResumoModalAberto(false)}
          closeText={nls.close}
          size='large'
          actions={(
            <Button color='default' onClick={() => setResumoModalAberto(false)}>
              {nls.close}
            </Button>
          )}
        >
          <div className='box-pdca-history-summary-modal'>
            <div className='box-pdca-history-summary-header' />

            <div className='box-pdca-history-summary-section'>
              <div className='box-pdca-history-summary-label'>
                {nls.summaryPeriod}
              </div>

              <div className='box-pdca-history-summary-period'>
                {resumo?.de} {nls.summaryTo} {resumo?.ate}
              </div>
            </div>

            <div className='box-pdca-history-summary-kpis'>
              <div className='box-pdca-history-summary-kpi'>
                <div className='box-pdca-history-summary-label'>
                  {nls.summaryTotalCompleted}
                </div>

                <div className='box-pdca-history-summary-value box-pdca-history-summary-value-primary'>
                  {resumo?.resumo?.total_concluidos ?? 0}
                </div>
              </div>

              <div className='box-pdca-history-summary-kpi'>
                <div className='box-pdca-history-summary-label'>
                  {nls.summaryNpsGain}
                </div>

                <div className='box-pdca-history-summary-value'>
                  {formatarValorTexto(resumo?.resumo?.nps_total_ganho, nls)}
                </div>
              </div>

              <div className='box-pdca-history-summary-kpi'>
                <div className='box-pdca-history-summary-label'>
                  {nls.summaryAverageImprovement}
                </div>

                <div className='box-pdca-history-summary-value'>
                  {formatarPercentual(resumo?.resumo?.melhoria_media_percentual, nls)}
                </div>
              </div>
            </div>

            <div className='box-pdca-history-summary-section'>
              <div className='box-pdca-history-summary-subtitle'>
                {nls.summaryReason}
              </div>

              <div className='box-pdca-history-summary-list'>
                {resumo?.resumo?.por_motivo?.padronizado !== undefined && (
                  <div className='box-pdca-history-summary-row'>
                    <span className='box-pdca-history-summary-row-label'>
                      {nls.padronizado}
                    </span>
                    <span className='box-pdca-history-summary-row-value'>
                      {resumo.resumo.por_motivo.padronizado}
                    </span>
                  </div>
                )}

                {resumo?.resumo?.por_motivo?.pivotado !== undefined && (
                  <div className='box-pdca-history-summary-row'>
                    <span className='box-pdca-history-summary-row-label'>
                      {nls.pivotado}
                    </span>
                    <span className='box-pdca-history-summary-row-value'>
                      {resumo.resumo.por_motivo.pivotado}
                    </span>
                  </div>
                )}

                {resumo?.resumo?.por_motivo?.escalonado !== undefined && (
                  <div className='box-pdca-history-summary-row'>
                    <span className='box-pdca-history-summary-row-label'>
                      {nls.escalonado}
                    </span>
                    <span className='box-pdca-history-summary-row-value'>
                      {resumo.resumo.por_motivo.escalonado}
                    </span>
                  </div>
                )}

                {resumo?.resumo?.por_motivo?.encerrado !== undefined && (
                  <div className='box-pdca-history-summary-row'>
                    <span className='box-pdca-history-summary-row-label'>
                      {nls.encerrado}
                    </span>
                    <span className='box-pdca-history-summary-row-value'>
                      {resumo.resumo.por_motivo.encerrado}
                    </span>
                  </div>
                )}

                {resumo?.resumo?.por_motivo?.rejeitado_plan !== undefined && (
                  <div className='box-pdca-history-summary-row'>
                    <span className='box-pdca-history-summary-row-label'>
                      {nls.rejeitado_plan}
                    </span>
                    <span className='box-pdca-history-summary-row-value'>
                      {resumo.resumo.por_motivo.rejeitado_plan}
                    </span>
                  </div>
                )}

                {resumo?.resumo?.por_motivo?.rejeitado_do !== undefined && (
                  <div className='box-pdca-history-summary-row'>
                    <span className='box-pdca-history-summary-row-label'>
                      {nls.rejeitado_do}
                    </span>
                    <span className='box-pdca-history-summary-row-value'>
                      {resumo.resumo.por_motivo.rejeitado_do}
                    </span>
                  </div>
                )}

                {resumo?.resumo?.por_motivo?.rejeitado_check !== undefined && (
                  <div className='box-pdca-history-summary-row'>
                    <span className='box-pdca-history-summary-row-label'>
                      {nls.rejeitado_check}
                    </span>
                    <span className='box-pdca-history-summary-row-value'>
                      {resumo.resumo.por_motivo.rejeitado_check}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Modal>

        <Detalheplano
          open={detalheOpen}
          close={() => setDetalheOpen(false)}
          planoId={planoIdSelecionado}
        />
      </div>
    </PdcaLayout>
  )
}